import { faArrowAltCircleRight } from '@fortawesome/free-regular-svg-icons';
import { faCalendarCheck, faClockFour } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardActionArea, CardContent, Chip, IconButton, Link, Typography, makeStyles } from '@material-ui/core';
import moment from "moment-timezone";
import React, { useEffect, useMemo, useState } from 'react';
import { parseBookingStatus } from 'util/bookingStates';
import { useTrackEvent } from 'util/trackEvent';

const useStyles = makeStyles(theme => ({
  datalist: {
    "&>p": {
      paddingBottom: theme.spacing(1)
    },
  },
  head: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  paddedcard:{ 
    
  }
}));
const BookingListItem = ({ booking }) => {
  const classes = useStyles()
  const trackEvent = useTrackEvent()

  const bookingPackages = useMemo(
    () => {
      if (booking?.extended_packages?.length > 0) {
        return <div className={classes.testContent}>
          <Typography variant="h6">
            {
              booking?.extended_packages?.map((item) => {
                return item?.package?.label
              }).join(', ')
            }

          </Typography>
        </div>
      }
      if (booking?.extended_package_items?.length > 0) {
        return <div className={classes.testContent}>
          <Typography variant="h6">
            {
              booking?.extended_package_items?.slice(0, 5)?.map((item) => {
                return item?.item?.label
              }).join(', ')
            }
            {
              booking?.extended_package_items?.length > 5 && (<Chip label={`+${booking?.extended_package_items?.length - 5} more`} />)
            }
          </Typography>
        </div>
      }
      return <></>
    }, [booking]
  );

  const bookingType = useMemo(
    () => {
      return (
        <Typography variant="h6">
          {booking?.type?.label}
        </Typography>
      )

    }, [booking]
  );

  const statusChip = useMemo(
    () => {
      const status = parseBookingStatus(booking)
      return (
        <Chip label={status.label} style={{
          backgroundColor: status.bgColor,
          color: status.textColor,
          fontWeight: 'bold'
        }} />
      )
    }, [booking]
  );


  const renderDate = useMemo(
    () => {
      const displayDate = booking?.date_scheduled || booking?.date_created
      if (!booking?.date_scheduled && booking?.date_created) {
        return moment(booking?.date_created).format('dddd LL - LT')
      }
      return `${moment(booking?.date_scheduled).format('dddd LL')} ${ moment(booking?.date_scheduled).format('LT') } - ${ moment(booking?.date_scheduled_end).format('LT') }`
    }, [booking]
  );
  return (
    <div className={classes.paddedcard}>
      <Card>
        <CardActionArea 
          onClick={()=>{
            trackEvent('Booking List open booking', {booking: booking.id})
          }}
          component={Link}
          href={`/bookings/${booking?.id}`}
          target='_blank'
          underline='none'
        >
          <CardContent className={classes.head}>
            <div className={classes.datalist}>
              {bookingType}
              {bookingPackages}
              <Typography variant="body1" color="textSecondary" component="p"><FontAwesomeIcon fixedWidth icon={faCalendarCheck} /> 
              {renderDate}
              </Typography>
              {statusChip}
            </div>
            <IconButton
              color='primary'
            >
              <FontAwesomeIcon icon={faArrowAltCircleRight} />
            </IconButton>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  )
}

export { BookingListItem }